import ModalHeader from '../ModalHeader';
import TroberButton from '../TroberButton';
import { NewsCard } from './components';
import { FC, useEffect, useRef, useState } from 'react';
import { Button, ButtonToolbar, Alert } from 'reactstrap';
import API from 'src/API';
import { useModal } from 'src/Hooks';
import { NewsType } from 'src/Types';

import './news.scss';

interface INewsModalProps {
	onClose: () => void;
	checkUnreadNews: () => void;
}

const NewsModal: FC<INewsModalProps> = ({ onClose, checkUnreadNews }) => {
	const wrapperRef = useRef<HTMLDivElement>(null);
	const [isLoading, setIsLoading] = useState(false);
	const [data, setData] = useState<NewsType[]>([]);
	const { showError } = useModal();
	const [count, setCount] = useState<number>(0);
	const [skipPage, setSkipPage] = useState(0);

	useEffect(() => {
		setIsLoading(true);
		API.Plugins.getNews(3, skipPage)
			.then((result) => {
				setData((prev) => {
					return [...prev, ...result.list];
				});
				setCount(result.count);
				if (!!wrapperRef.current && data.length > 3) {
					wrapperRef.current.scrollBy({
						top: wrapperRef.current.scrollHeight,
						behavior: 'smooth',
					});
				}
			})
			.catch((e: any) => {
				showError(e.message, 'Ошибка при получении новостей');
			})
			.finally(() => {
				return setIsLoading(false);
			});
		// eslint-disable-next-line
	}, [skipPage]);

	const onSetAsReadHandler = () => {
		API.Plugins.setAsRead()
			.then(() => {
				return checkUnreadNews();
			})
			.catch((e: any) => {
				console.warn(e);
				showError(e.message, 'Новости Re:Doc');
			})
			.finally(() => {
				return onClose();
			});
	};

	const onShowMoreHandler = () => {
		setSkipPage((prev) => {
			return (prev += 1);
		});
	};

	const renderContent = () => {
		if (data.length) {
			return (
				<>
					<div className="rdc_news_wrapper" ref={wrapperRef}>
						{data.map((item: NewsType) => {
							return (
								<NewsCard
									key={item.recId}
									content={item.content}
									title={item.title}
									updateDate={item.updateDate}
								/>
							);
						})}
					</div>

					{data.length < count && (
						<TroberButton
							isWaiting={isLoading}
							block
							onClick={onShowMoreHandler}
						>
							&hellip; Показать еще
						</TroberButton>
					)}
				</>
			);
		} else {
			return (
				<Alert color="success">
					<h5 className="offset-md-4">Новостная лента пуста</h5>
				</Alert>
			);
		}
	};

	const renderFooter = () => {
		return (
			<ButtonToolbar className="rdc_news-tb">
				<Button
					color="success"
					onClick={onSetAsReadHandler}
					disabled={!data.length}
				>
					&#10004; Прочитано
				</Button>
				<Button outline onClick={onClose}>
					Закрыть
				</Button>
			</ButtonToolbar>
		);
	};

	return (
		<div className="modal-overlay">
			<div className="modal-window rdc_news-modal">
				<ModalHeader onClose={onClose}>
					Новостная лента Re:Doc
				</ModalHeader>
				{renderContent()}
				{renderFooter()}
			</div>
		</div>
	);
};

export default NewsModal;
